(function(){
    var previewParams = new URLSearchParams(window.location.search);
    if (previewParams.get('booking-preview') === '1')
        return;

    function scrollToContent() {
        if (window.location.hash === ''|| window.location.hash === '#' || window.location.hash === '#/' || window.location.hash === '#/service')
            return;
        var content = document.querySelector('.content');
        window.scrollTo(0, content.offsetTop - 20);
    }

    window.addEventListener('hashchange', function () {
        var empty;
        var emptyChanged = false;
        var select = document.querySelector('.cb-select select');
        var prev = document.querySelector('.cb-calendar-prev a');
        var next = document.querySelector('.cb-calendar-next a');
        function handleChange(e) {
            if (empty && emptyChanged) {
                empty.innerText = '';
                emptyChanged = false;
            }
            handleEmpty();
        }
        if (select)
            select.addEventListener('change', handleChange);
        if (prev)
            prev.addEventListener('click', handleChange);
        if (next)
            next.addEventListener('click', handleChange);
        setTimeout(function () {
            var summary = document.querySelector('.cb-summary-toggle a');
            if (summary)
                summary.click();
            scrollToContent();
        }, 100);
        function handleEmpty() {
            setTimeout(function () {
                empty = document.querySelector('.cb-calendar-week-empty p');
                if (empty && (empty.innerHTML === '' || empty.innerText == "Hittade inga lediga tider inom de närmaste 6 månaderna")) {
                    if (select.value === 'ALL')
                        empty.innerHTML = "<div class='its-full'><b>Hittar du inga lediga tider hos oss?</b><br><br>Onlinebokningen visar tider 2 månader framåt för att lämna plats åt stamkunder. Stammisar är välkomna att maila för en tid längre fram. Du kan även maila oss för att sätta upp dig på återbudslistan så hör vi av oss om det blir ett återbud <a class='email-tag' href='mailto:team@peachstockholm.se?Subject=Kontakt'>team@peachstockholm.se</a></div>";
                    else
                        empty.innerHTML = "<div class='its-full'><b>Hittar du inga lediga tider hos mig?</b><br><br>Onlinebokningen visar tider 2 månader framåt för att lämna plats åt mina stamkunder. Stammisar är välkomna att maila för en tid längre fram. Du kan även maila oss för att sätta upp dig på återbudslistan så hör vi av oss om det blir ett återbud <a class='email-tag' href='mailto:team@peachstockholm.se?Subject=Kontakt'>team@peachstockholm.se</a></div>";
                    emptyChanged = true;
                }
                scrollToContent();
            }, 800);
        }
        handleEmpty();
        scrollToContent();
    }, false);
})();